import { render, staticRenderFns } from "./ModalAgenda.vue?vue&type=template&id=070facbe&scoped=true&lang=pug"
import script from "./ModalAgenda.vue?vue&type=script&lang=js"
export * from "./ModalAgenda.vue?vue&type=script&lang=js"
import style0 from "./ModalAgenda.vue?vue&type=style&index=0&id=070facbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070facbe",
  null
  
)

export default component.exports